import React from 'react';

export type IconName =
  | 'home'
  | 'services'
  | 'globe'
  | 'gift'
  | 'phone'
  | 'social'
  | 'wallet'
  | 'card'
  | 'link'
  | 'activity'
  | 'settings'
  | 'help'
  | 'arrow'
  | 'plus'
  | 'check'
  | 'info'
  | 'lock'
  | 'download';
const paths: Record<IconName, string> = {
  services: 'M3 3h7v7H3Z M14 3h7v7h-7Z M3 14h7v7H3Z M14 14h7v7h-7Z',
  globe:
    'M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20 M2 12h20 M12 2c-5 6-5 14 0 20 M12 2c5 6 5 14 0 20',
  gift: 'M3 8h18v4H3Z M5 12v9h14v-9 M12 8v13 M12 8C3 8 5 0 9 3l3 5c9 0 7-8 3-5Z',
  phone: 'M7 2h10a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1Z M10 18h4',
  social: 'M4 5h16v12H9l-5 4Z M8 9h8 M8 13h5',
  home: 'M3 10 12 3l9 7v10a1 1 0 0 1-1 1h-5v-7H9v7H4a1 1 0 0 1-1-1Z',
  wallet: 'M20 7V5a2 2 0 0 0-2-2H5a2 2 0 0 0 0 4h15v14H5a2 2 0 0 1-2-2V5 M20 11h-6v6h6 M17 14h.01',
  card: 'M4 4h16a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1Z M3 9h18 M7 15h3',
  link: 'M10 13a5 5 0 0 0 7 0l3-3a5 5 0 0 0-7-7l-2 2 M14 11a5 5 0 0 0-7 0l-3 3a5 5 0 0 0 7 7l2-2',
  activity: 'M3 12h4l3-8 4 16 3-8h4',
  settings:
    'M12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8 M12 2v2 M12 20v2 M2 12h2 M20 12h2 M5 5l2 2 M17 17l2 2 M5 19l2-2 M17 7l2-2',
  help: 'M9 9a3 3 0 1 1 4 3c-1 0-1 1-1 2 M12 17h.01 M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20',
  arrow: 'M4 12h16 M14 6l6 6-6 6',
  plus: 'M12 5v14 M5 12h14',
  check: 'm5 12 4 4L19 6',
  info: 'M12 11v6 M12 7h.01 M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20',
  lock: 'M6 10h12v11H6Z M8 10V6a4 4 0 0 1 8 0v4 M12 14v3',
  download: 'M12 3v12 M7 10l5 5 5-5 M4 17v4h16v-4',
};
export const AppIcon: React.FC<{ readonly name: IconName }> = ({ name }) => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.65"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d={paths[name]} />
  </svg>
);
